import { useCallback, useEffect, useState, useMemo } from "react";
import ReactTableWrapper from "../../components/ReactTableWrapper";
import ListFormPageHeader from "../../components/ListFormPageHeader";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { openPdfResponse } from "../../utils/openPdfInApp";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Sidebar from '../../Sidebar';
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import { displayError } from "../../helpers";
import ListPageGradientSummary from "../../components/ListPageGradientSummary";
import { buildGradientCard, formatRecordStatus, splitRecordsByStatus, sumField, formatQty } from "../../utils/listSummaryUtils";
import moment from 'moment';
import { getListViewSettings } from "../../services/SettingsServices";
import { buildSalesOrderQueryParams, DEFAULT_LIST_VIEW_CONFIG } from "../../utils/listViewDateRanges";
import { getAllSalesOrder, deleteSalesOrder,printSalesOrder,printProformaInvoice} from "../../services/SalesOrderServices";
function SalesOrderTable() {
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [refreshKey, setRefreshKey] = useState(0);
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(false); 

    const todayDateLabel = moment().format('DD-MM-YYYY');

    const { active: activeRecords, cancelled: cancelledRecords } = useMemo(
        () => splitRecordsByStatus(data.records),
        [data.records],
    );

    const highlightCard = useMemo(() => {
        const todayCount = data.records.filter((row) => row.order_date === todayDateLabel).length;
        return buildGradientCard('Today SO', todayCount, 'today');
    }, [data.records, todayDateLabel]);

    const summaryCards = useMemo(() => {
        const cards = [
            buildGradientCard('Total', data.records.length, 'blue'),
            buildGradientCard('Order Qty', formatQty(sumField(activeRecords, 'quantity')), 'purple'),
            buildGradientCard('Schedule Qty', formatQty(sumField(activeRecords, 'scheduled_qty')), 'teal'),
            buildGradientCard('Supplied Qty', formatQty(sumField(activeRecords, 'supplied_qty')), 'blue'),
            buildGradientCard('Balance Qty', formatQty(sumField(activeRecords, 'balance_qty')), 'purple'),
        ];
        const cancelledQty = sumField(cancelledRecords, 'quantity');
        if (cancelledRecords.length && cancelledQty > 0) {
            cards.push(buildGradientCard('Cancelled Order Qty', formatQty(cancelledQty), 'red'));
        }
        return cards;
    }, [data.records.length, activeRecords, cancelledRecords]);

    const right_pinned = ["id"];

    const columns = useMemo(
        () => [
            {
                fieldName: 'order_no', 
                headerName: 'SO No'
            },
           
            {
                fieldName: "order_date",
                headerName: 'SO Date'
            },
            {
                fieldName: "purchase_order_no",
                headerName: 'PO No'
            },
            {
                fieldName: "purchase_order_date",
                headerName: 'PO Date'
            },
            {
                fieldName: "salesrep",
                headerName: 'Marketing Name'
            },
            {
                fieldName: "customer",
                headerName: 'Customer'
            },
            {
                fieldName: "consignee",
                headerName: 'Site / Project'
            },
            {
                fieldName: "product",
                headerName: 'Grade'
            },
            {
                fieldName: "rate",
                headerName: 'Rate'
            },
            {
                fieldName: "quantity",
                headerName: 'Order Qty'
            },
            {
                fieldName: "scheduled_qty",
                headerName: 'Schedule Qty'
            },
            {
                fieldName: "supplied_qty",
                headerName: 'Supplied Qty'
            },
            {
                fieldName: "balance_qty",
                headerName: 'Balance Qty'
            },
            {
                fieldName: "delivery_mode",
                headerName: 'Delivery Mode'
            },
            {
                fieldName: "is_approved",
                headerName: 'Approval Status'
            },
            {
                fieldName: "status",
                headerName: 'Status'
            },
            {
                fieldName: "id",
                headerName: "ROW_ACTIONS"
            }
        ],
        [],);

    const onEditSalesOrder = (SalesOrderId, event) => {
       navigate(`/SalesOrderEdit/${SalesOrderId}/`);
    };

    const onDeleteSalesOrder = (SalesOrderId, event) => {
        event.preventDefault();
        Swal.fire({title: 'Are you sure to Delete?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) { 

            setIsLoading(true);
            deleteSalesOrder(cookies, SalesOrderId)
            .then(response => {
                console.log(`Sales Order with id ${SalesOrderId} deleted`);
                setRefreshKey(oldKey => oldKey +1);
                Swal.fire('Deleted Successfully!', '', 'success');
            })
            .catch(error => {
                setRefreshKey(oldKey => oldKey +1);
                console.log(error.response.data);
                displayError(error.response.data,'Delete Failed');
            }); 
            
            
          } else if (result.isDismissed) {    
            Swal.fire('Not Deleted', '', 'info')  
        }
        });
        //

    };

    const handleCSVExport = (event) => {
        console.log('CSV Export');
        exportAsCSV(
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(c => c.headerName),
            data.records.map(salesorder => {

                const csvRow = {
                    order_no : salesorder.order_no,
                order_date: salesorder.order_date,
                purchase_order_no:salesorder.purchase_order_no,
                purchase_order_date:salesorder.purchase_order_date,
                customer: salesorder.customer,
                salesrep:salesorder.salesrep,
                consignee : salesorder.consignee,
                product: salesorder.product,
                quantity:salesorder.quantity,
                rate : salesorder.rate,
                scheduled_qty: salesorder.scheduled_qty,
                supplied_qty:salesorder.supplied_qty,
                balance_qty : salesorder.balance_qty,
                delivery_mode: salesorder.delivery_mode,
                is_approved:salesorder.is_approved,
                status:salesorder.status,
                }
                return csvRow;
                }));
    };

    const handlePDFExport = (event) => {
        console.log('PDF Export');
        exportAsPDF(
            'List of Sales Order Form',
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(salesorder => ({
                order_no : salesorder.order_no,
                order_date: salesorder.order_date,
                purchase_order_no:salesorder.purchase_order_no,
                purchase_order_date:salesorder.purchase_order_date,
                customer: salesorder.customer,
                salesrep:salesorder.salesrep,
                consignee : salesorder.consignee,
                product: salesorder.product,
                quantity:salesorder.quantity,
                rate : salesorder.rate,
                scheduled_qty: salesorder.scheduled_qty,
                supplied_qty:salesorder.supplied_qty,
                balance_qty : salesorder.balance_qty,
                delivery_mode: salesorder.delivery_mode,
                is_approved:salesorder.is_approved,
                status:salesorder.status,
            })),
            'salesorder.pdf'
        );
    };

    const onPrintSalesOrder = (SalesOrderId, event) => {
        event.preventDefault();
        printSalesOrder(cookies, SalesOrderId)
        .then(response => {
            openPdfResponse(response, {
                title: 'Sales Order',
                downloadFileName: 'salesorder.pdf',
            });
        })
        .catch(error => {
            console.log(error);
            displayError(error,'Print Failed');
        });  
    };

    const onPrintproformaInvoice = (deliveryId, event) => {
        event.preventDefault();
        printProformaInvoice(cookies, deliveryId)
        .then(response => {
            openPdfResponse(response, {
                title: 'Proforma Invoice',
                downloadFileName: 'proforma_invoice.pdf',
            });
        })
        .catch(error => {
            console.log(error);
            displayError(error,'BR print Failed');
        });  
    };

    const loadSalesOrderList = useCallback((config) => {
        if (!cookies.myToken) {
            setIsLoading(false);
            return;
        }
        const activeConfig = config || DEFAULT_LIST_VIEW_CONFIG;
        setIsLoading(true);
        getAllSalesOrder(cookies, buildSalesOrderQueryParams(activeConfig))
        .then((salesorderList) => {
            const tableData = (salesorderList?.sales_order_list || [])
            .map(salesorder => {
                const isActive = Boolean(salesorder.status);
                return {
                id :salesorder.id,
                order_no : salesorder.order_no,
                order_date: salesorder.order_date,
                purchase_order_no:salesorder.purchase_order_no,
                purchase_order_date:salesorder.purchase_order_date,
                customer: salesorder.consignee?.customer?.name || '',
                salesrep:salesorder.consignee?.customer?.salesrep?.name || '',
                consignee : salesorder.consignee?.project_name || '',
                product: salesorder.product?.name || '',
                quantity:salesorder.quantity,
                rate : salesorder.rate,
                scheduled_qty: salesorder.scheduled_qty,
                supplied_qty:salesorder.supplied_qty,
                balance_qty : salesorder.balance_qty,
                delivery_mode: salesorder.delivery_mode,
                is_approved:salesorder.is_approved,
                status: formatRecordStatus(isActive),
                is_inactive: !isActive,
                is_batch_report_needed:'Yes',
                hide_row_print:'No'
            };
            });

            setData({
                total: tableData.length,
                records: tableData
            });
        })
        .catch((error) => {
            setData({ records: [] });
            displayError(error.response?.data ?? error.message, 'Failed to load sales orders');
        })
        .finally(() => {
            setIsLoading(false);
        });
    }, [cookies]);

    const handleSettingsSaved = useCallback((config) => {
        loadSalesOrderList(config);
    }, [loadSalesOrderList]);

    useEffect(() => {
        if (!cookies.myToken) {
            setIsLoading(false);
            return;
        }
        getListViewSettings(cookies, 'sales_order')
            .then((response) => {
                loadSalesOrderList(response.config || DEFAULT_LIST_VIEW_CONFIG);
            })
            .catch(() => {
                loadSalesOrderList(DEFAULT_LIST_VIEW_CONFIG);
            });
    }, [cookies, cookies.myToken, loadSalesOrderList, refreshKey]);
    
    return (

        <div id="outer-container"  className="App" > 
            <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
            <div id="page-wrap">
                <ListFormPageHeader
                    module="MARKETING"
                    title="List of Sales Orders"
                    viewKey="sales_order"
                    onSettingsSaved={handleSettingsSaved}
                    formLink="/SalesOrder"
                    addNewLabel="New Sales Order"
                />

                <ListPageGradientSummary highlightCard={highlightCard} cards={summaryCards} />

                <div className="container item-list-table-container">
                <div className="table-responsive">
                <ReactTableWrapper
                            title='List of Group Form'
                            columns={columns}
                            data={data.records}
                            onRowEdit={onEditSalesOrder}
                            onRowDelete={onDeleteSalesOrder}
                            onRowPrint={onPrintSalesOrder}
                            hidePrint ={false}
                            onCSVExport={handleCSVExport}
                            onPDFExport={handlePDFExport}
                            isLoading={isLoading}
                            hideDelete={true}
                            onRowBrPrint={onPrintproformaInvoice}
                            right_pinned={right_pinned}
                            compactColumns={true}
                        />
                </div>
                </div> 


            </div>
            <button style={{position:"relative",right:"40px"}}className="btn btn-fill btn-primary float-end" type="button" onClick={() =>{navigate("/SalesOrder")}}>Back</button>
        </div>

        
    );

}



export default SalesOrderTable;
